// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBj2KaZGFxX4hvhV1_0B1oeh6n0v9rk1hc",
  authDomain: "heroic-game-day.firebaseapp.com",
  projectId: "heroic-game-day",
  storageBucket: "heroic-game-day.appspot.com",
  messagingSenderId: "39399506248",
  appId: "1:39399506248:web:bce93e3a5e2b3d5139b37d",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
